import { render, staticRenderFns } from "./LinhaDaTabela.vue?vue&type=template&id=171e5d68&scoped=true"
import script from "./LinhaDaTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDaTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDaTabela.vue?vue&type=style&index=0&id=171e5d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171e5d68",
  null
  
)

export default component.exports